import { Dilenske } from './dilenske';
import { Firemni } from './firemni';
import { Koncernove } from './koncernove';
import { NoveVozy } from './noveVozy';
import { OjeteVozy } from './ojeteVozy';
import { Pneu } from './pneu';
import { Pujcovna } from './pujcovna';
import { Skladove } from './skladove';
import { Zakaznicke } from './zakaznicke';
import { DMS_MODULE as name } from './constants';
import { LocationMaster } from './LocationMaster';

export const menu = {
	name,
	list: [
		Skladove.menu,
		{ name: 'LocationMaster', route: LocationMaster.name },
		Koncernove.menu,
		Firemni.menu,
		Zakaznicke.menu,
		Dilenske.menu,
		NoveVozy.menu,
		OjeteVozy.menu,
		Pujcovna.menu,
		Pneu.menu,
	],
};
